/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CampaignsGetResponse } from '../models/CampaignsGetResponse';
import type { CRegion } from '../models/CRegion';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CampaignsService {
    /**
     * @param skip
     * @param take
     * @param noCache
     * @param matchDomain
     * @param searchTerm
     * @param region
     * @returns CampaignsGetResponse OK
     * @throws ApiError
     */
    public static getLandingpage(
        skip?: any,
        take?: any,
        noCache: boolean = false,
        matchDomain?: string,
        searchTerm?: string,
        region?: CRegion,
    ): CancelablePromise<CampaignsGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Campaigns',
            query: {
                'skip': skip,
                'take': take,
                'noCache': noCache,
                'matchDomain': matchDomain,
                'searchTerm': searchTerm,
                'region': region,
            },
        });
    }
}
